export default {
  title: "Баланс",
  balanceInfo: {
    title: "Баланс жөнүндө маалымат",
    subtitle:
      "Баланста көрсөтүлгөн RC бардык операциялар боюнча өзара эсептөөлөрдү жүргүзгөндөн кийин эсепте күтүлүүчү сумма болуп саналат.",
    moreDetailSpoiler: {
      ru: [
        {
          title: "Иш жүзүндөгү баланс",
          description: [
            {
              type: "text",
              value:
                "Банк аркылуу балансты толтуруу, жокко чыгарылган операциялар боюнча кайтарымдар, кардарлардан накталган баллдарды камтыйт. Сыйақы бөлүштүрүү сценарийлерине ылайык баллдарды төлөө, тариф жана кызматтарды сатып алуу үчүн алып салуулар, ошондой эле «Төлөөгө резервделген» суммасы (орнотулган болсо) чыгарылгандан кийинки сумма.",
            },
          ],
        },
        {
          title: "Накталоону күтүүдө",
          description: [
            {
              type: "text",
              value:
                "Сиздин иш жүзүндөгү балансыңызда өзара эсептөө жүргүзүү үчүн каражат жеткисиз болгондуктан, азырынча накталанбаган кардарлардан баллдар. Бул жерге ошондой эле кардарлар саякаты (сиз сандаштырган кардарларыңыздын башка мекемелерге баруусунан келген сыйақы) кирет, ал накталоону күтүүдө. Эгерде сиз сандаштырган кардарыңыз баруган мекеме ээсинин эсебинде каражат жеткисиз болсо, күтүү пайда болот.",
            },
          ],
        },
        {
          title: "Алып салууну күтүүдө",
          description: [
            {
              type: "text",
              value:
                "Каражат жеткисиздиги себебинен, ошондой эле эгерде мекемеде нактоо кечиктирилиши орнотулган болсо, азырынча алынып салынбаган баллдар (сыйақы бөлүштүрүү сценарийлерине ылайык).",
            },
          ],
        },
        {
          title: "Чыгарууга жеткиликтүү",
          description: [
            {
              type: "text",
              value:
                "Алып салууну күтүп турган каражаттарды, белгиленген депозит суммасын, ошондой эле «Төлөөгө резервделген» суммасын (орнотулган болсо) чыгарып, иш жүзүндөгү баланс.",
            },
          ],
        },
        {
          title: "Төлөөгө резервделген",
          description: [
            {
              type: "text",
              value: "Өзара эсептөө мезгилинде иш жүзүндө төлөнө турган сумма.",
            },
            {
              type: "text",
              value:
                "Айына 2 жолу баланс орнотууларында 300 RCден кем эмес жана учурдагы «Чыгарууга жеткиликтүү» балансынан ашпаган көлөмдө белгиленет. Төлөө суммасын орнотуу үчүн, каражат чыгарууну орноткуңыз келген юридикалык жактын баланс карточкасындагы «Орнотуулар» баскычын басыңыз.",
            },
            {
              type: "text",
              value:
                "Эгерде өзара эсептөөлөрдү жүргүзүүдөн мурун сумма орнотулбаса жана «Чыгарууга жеткиликтүү» баланс суммасы боюнча каражат чыгаруу күйгүзүлбөсө, каражат чыгаруу жүргүзүлбөйт.",
            },
            {
              type: "text",
              value:
                "Баланстан төлөө үчүн каражаттарды алуунун болжолдуу даталары - ар айдын 1-5 жана 16-20. Эсептерге төлөм кабинеттеги баланстан алынып салынган күндөн кийин 14 күн ичинде жүргүзүлөт.",
            },
          ],
        },
        {
          title: "Дал келтирүү актысы",
          description: [
            {
              type: "v-text",
              value:
                "Дал келтирүү жана&nbsp;жүзөгө ашырылган иштердин актыларын&nbsp;колдоо кызматы аркылуу алууга болот. Бул&nbsp;үчүн RC CITY кабинетинен төмөнкү оң бурчтагы тескери байланыш формасы аркылуу сураныч жибериңиз же&nbsp;электрондук почтага кат жөнөтүңүз <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Суранычта төмөнкүлөрдү көрсөтүү керек:",
              list: [
                "ИНН",
                "Юридикалык жактын аталышы",
                "Дал келтирүү актысы керек болгон меер же акт керек болгон суммалар",
              ],
            },
          ],
        },
      ],
      noRu: [
        {
          title: "Иш жүзүндөгү баланс",
          description: [
            {
              type: "text",
              value:
                "Банк аркылуу балансты толтуруу, жокко чыгарылган операциялар боюнча кайтарымдар, кардарлардан накталган баллдарды камтыйт. Сыйақы бөлүштүрүү сценарийлерине ылайык баллдарды төлөө жана тариф жана кызматтарды сатып алуу үчүн алып салуулар чыгарылгандан кийинки сумма.",
            },
          ],
        },
        {
          title: "Накталоону күтүүдө",
          description: [
            {
              type: "text",
              value:
                "Сиздин иш жүзүндөгү балансыңызда өзара эсептөө жүргүзүү үчүн каражат жеткисиз болгондуктан, азырынча накталанбаган кардарлардан баллдар. Бул жерге ошондой эле кардарлар саякаты (сиз сандаштырган кардарларыңыздын башка мекемелерге баруусунан келген сыйақы) кирет, ал накталоону күтүүдө. Эгерде сиз сандаштырган кардарыңыз баруган мекеме ээсинин эсебинде каражат жеткисиз болсо, күтүү пайда болот.",
            },
          ],
        },
        {
          title: "Алып салууну күтүүдө",
          description: [
            {
              type: "text",
              value:
                "Каражат жеткисиздиги себебинен, ошондой эле эгерде мекемеде нактоо кечиктирилиши орнотулган болсо, азырынча алынып салынбаган баллдар (сыйақы бөлүштүрүү сценарийлерине ылайык).",
            },
          ],
        },
        {
          title: "Чыгарууга жеткиликтүү",
          description: [
            {
              type: "text",
              value:
                "Алып салууну күтүп турган каражаттарды жана белгиленген депозит суммасын чыгарып, иш жүзүндөгү баланс.",
            },
          ],
        },
        {
          title: "Дал келтирүү актысы",
          description: [
            {
              type: "v-text",
              value:
                "Дал келтирүү жана&nbsp;жүзөгө ашырылган иштердин актыларын&nbsp;колдоо кызматы аркылуу алууга болот. Бул&nbsp;үчүн RC CITY кабинетинен төмөнкү оң бурчтагы тескери байланыш формасы аркылуу сураныч жибериңиз же&nbsp;электрондук почтага кат жөнөтүңүз <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Суранычта төмөнкүлөрдү көрсөтүү керек:",
              list: [
                "ИНН",
                "Юридикалык жактын аталышы",
                "Дал келтирүү актысы керек болгон меер же акт керек болгон суммалар",
              ],
            },
          ],
        },
      ],
    },
  },
  aboutChapter: {
    title: "Бөлүм жөнүндө маалымат",
    description: [
      "Баланс — бул эсептешүү мезгилинде сизге төлөнө турган каражаттар тууралуу маалымат.",
      "Ошондой эле баланс баракчасында сиздин финансыңызды көзөмөлдөөгө жана учурдагы абалын түшүнүүгө жардам берген толук детализация берилет.",
    ],
  },
  withdrawalInstructionName:
    "RC CITY кабинетинен каражат чыгаруу боюнча нускама",
  reservedForPayment: "Төлөөгө резервделген",
  withdrawalOfFund: "Каражат чыгаруу",
  power: {
    on: "Күйгүзүлгөн",
    off: "Өчүрүлгөн",
  },
  actualBalance: "Иш жүзүндөгү баланс",
  expectedCredited: "Накталоону күтүүдө",
  expectedDebiting: "Алып салууну күтүүдө",
  availableWithdrawal: "Чыгарууга жеткиликтүү",
  statusText: {
    needAdjustPaymentMethod: "Каражат чыгаруу үчүн төлөм ыкмасын орнотуу керек",
    bySumReservedOnBalance: "Төлөөгө чейин баланста резервделген сумма боюнча",
    bySumAvailableToWithdrawal:
      "Өзара эсептөөлөрдү жүргүзүү убагындагы «Чыгарууга жеткиликтүү» суммасы боюнча",
  },

  topupModal: {
    title: "Толтуруунун суммасын көрсөтүңүз",
    entityPayer: "Юридикалык жак — төлөөчү",
    topupSum: "Толтуруунун суммасы",
  },
  createAndDownloadAccount: "Эсеп-фактураны түзүп жүктөп алыңыз",
  byReservedSum: "«Төлөөгө резервделген» суммасы боюнча",
  byAvailableSum: "«Чыгарууга жеткиликтүү» суммасы боюнча",
  bySettedSum: "Белгиленген сумма боюнча",
  bySettedSumDesc:
    "Каражат төлөөгө чейин резервге алынат, аларды тариф жана кызматтарды сатып алуу үчүн колдонбоого болот, себеби иш жүзүндөгү баланс белгиленген мааниге азаят. «Чыгарууга жеткиликтүү» суммасынын мааниси 300 RCден аз болгондо ыкма жеткиликтүү эмес.",
  byAvailableSumDesc:
    "Каражат төлөмдөрү өзара эсептөөлөрдү жүргүзүү убагындагы «Чыгарууга жеткиликтүү» балансынын маанисине барабар суммада жүргүзүлөт, эгерде ал 300 RCден кем болбосо.",
  success: "Ийгиликтүү",
  settings: {
    title: "Каражат чыгарууну орнотуулар",
    banner: {
      inProgress: {
        title: "Төлөмдөр жүргүзүлүүдө",
        description: [
          "Төлөмдөр мезгилинде каражат чыгаруунун орнотууларын өзгөртүү жеткиликтүү эмес.",
          "Кийинки төлөм үчүн орнотууларды учурдагы каражат төлөм процесси аяктагандан кийин орното аласыз.",
        ],
      },
      inPending: {
        title: "Каражат төлөмү күтүлүүдө",
        description: [
          "Ал келишимдин 4.6-пунктуна ылайык жүргүзүлөт. Баланстан төлөө үчүн каражаттарды алуунун болжолдуу даталары - ар айдын 1-5 жана 16-20. Эсептерге төлөм кабинеттеги баланстан алынып салынган күндөн кийин 14 күн ичинде жүргүзүлөт.",
          "Төлөмдү алуудан баш тартуу, төлөм ыкмасын өзгөртүү же башка сумма орнотуу үчүн «Каражат чыгарууну өчүрүү» баскычын басыңыз.",
        ],
      },
      inDisabled: {
        title: "Каражат чыгаруу өчүрүлгөн",
        description: [
          "Каражат чыгаруу үчүн төлөм ыкмасын тандап, орнотууларды колдонуңуз. Төлөм келишимдин 4.6-пунктуна ылайык жүргүзүлөт.",
          "Баланстан төлөө үчүн каражаттарды алуунун болжолдуу даталары - ар айдын 1-5 жана 16-20. Эсептерге төлөм кабинеттеги баланстан алынып салынган күндөн кийин 14 күн ичинде жүргүзүлөт.",
          "Эгерде эч нерсе тандалбаса, көрсөтүлгөн меерде бул юридикалык жак үчүн каражат төлөмү жүргүзүлбөйт.",
        ],
      },
    },
    paymentMethod: "Төлөм ыкмасы",
    sumToBePaid: "Төлөөгө сумма",
    validSumTobePaidValid:
      "300 RCден кем эмес жана учурдагы «Чыгарууга жеткиликтүү» балансынын маанисинен ашпаган сумманы орното аласыз",
    entity: "Юридикалык жак",
    notSelectedNoPayment: "Тандалган эмес, төлөм жүргүзүлбөйт",
    bank: {
      BIC: "Банктын БИКи",
      naming: "Банктын аталышы",
      paymentAccount: "Эсептин номуру",
      corpAccount: "Корсчет",
      depositAmount: "Депозит суммасы",
      depositAmountHint:
        "Эсептеги минималдуу калдык. Каражат чыгарганда баланста кала турган сумма.",
      changeDetails: "Реквизиттерди өзгөртүү",
    },
    disableWithdrawal: "Каражат чыгарууну өчүрүү",
    disabledWithdrawalForDefinEntity:
      "{entityName} юридикалык жагы үчүн каражат чыгаруу өчүрүлгөн",
  },
  editPaymentModal: {
    title: "Банк реквизиттерин же депозит суммасын өзгөрткүңүз келеби?",
    subtitle:
      "Редакциялоо үчүн сиз «Юридикалык жактар» бөлүмчөсүнө өткөрүлөсүз. Өзгөртүүлөрдү киргизгенден кийин, жаңы реквизиттер боюнча каражат чыгарууну орното алуу үчүн «Баланс» бетине кайтыңыз.",
    toEdit: "Редакциялоого",
  },
  resetPaymentModal: {
    title: "Каражат чыгаруунун орнотууларын жокко чыгаргыңыз келеби?",
    subTitle:
      "«Ооба, жокко чыгаруу» баскычын басканда, каражат чыгаруунун орнотуулары нөлдөлөт. Бул юридикалык жак үчүн акча каражаттарын төлөө жүргүзүлбөйт.",
    yesCancel: "Ооба, жокко чыгаруу",
  },
  disabledPaymentModal: {
    title: "Каражат чыгарууну өчүрүүнү ырастаңыз",
    subtitle: {
      withFullWithdrawal: [
        "«Ырастоо» баскычын басуу менен, мурун орнотулган төлөө суммасы резервден алынат. Андан кийин сиз төлөм ыкмасын өзгөртө аласыз же жаңы төлөө суммасын орното аласыз.",
        "Эгерде жаңы каражат чыгаруу ыкмасы тандалбаса, бул юридикалык жак үчүн төлөм жүргүзүлбөйт.",
        "Маанилүү! Жаңы төлөө суммасын орнотуу «Чыгарууга жеткиликтүү» балансынын чегинде гана мүмкүн болот, анын мааниси резервден кийин учурдагыдан айырмаланышы мүмкүн.",
      ],
      withoutFullWithdrawal: [
        "Өчүргөндөн кийин аны кайра күйгүзүү же башка төлөм ыкмасын тандап алса болот.",
        "Эгерде жаңы каражат чыгаруу ыкмасы тандалбаса, бул юридикалык жак үчүн төлөм жүргүзүлбөйт.",
      ],
    },
  },
  errorCard: {
    title: "Карызыңызды төлөңүз",
    description:
      "Электрондук почтаңызга жөнөтүлгөн эсеп-фактураны жүктөп алып төлөңүз же «Толуктоо» баскычын басып, аны өз алдынча түзүңүз.",
  },
};
